import { computed, input } from '@angular/core';
import { Marked } from 'marked';
import { INCOMPLETE_MARKDOWN_LINK_REGEX, MARKDOWN_RENDERER_OPTIONS } from 'AIChatApp/constants/ai-chat.constant';
import { AgentMessageCopyButtonComponent } from 'AgentApp/ts/features/agent/components/agent-message-copy-button/agent-message-copy-button.component';
import { AgentLinkInterceptDirective } from 'AgentApp/ts/features/agent/directives/agent-link-intercept.directive';
import * as i0 from "@angular/core";
function AgentResponseMessageComponent_For_5_Conditional_0_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr");
} }
function AgentResponseMessageComponent_For_5_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AgentResponseMessageComponent_For_5_Conditional_0_Conditional_0_Template, 1, 0, "hr");
    i0.ɵɵelementStart(1, "div", 5)(2, "div", 6)(3, "a", 7);
    i0.ɵɵelement(4, "span", 8);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const action_r2 = ctx_r0.$implicit;
    const $index_r3 = ctx_r0.$index;
    i0.ɵɵconditional($index_r3 === 0 ? 0 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("href", action_r2.display_result.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", action_r2.display_result.title);
} }
function AgentResponseMessageComponent_For_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AgentResponseMessageComponent_For_5_Conditional_0_Template, 5, 3);
} if (rf & 2) {
    const action_r2 = ctx.$implicit;
    i0.ɵɵconditional(action_r2.display_result ? 0 : -1);
} }
const marked = new Marked({ renderer: { ...MARKDOWN_RENDERER_OPTIONS } });
export class AgentResponseMessageComponent {
    constructor() {
        this.messageText = input.required(...(ngDevMode ? [{ debugName: "messageText" }] : []));
        this.includeResponseProfileImage = input(false, ...(ngDevMode ? [{ debugName: "includeResponseProfileImage" }] : []));
        this.displayActions = input([], ...(ngDevMode ? [{ debugName: "displayActions" }] : []));
        this.messageHtml = computed(() => {
            const cleanedContent = this.messageText().replace(INCOMPLETE_MARKDOWN_LINK_REGEX, '*Creating Link...*');
            return marked.parse(cleanedContent);
        }, ...(ngDevMode ? [{ debugName: "messageHtml" }] : []));
    }
}
AgentResponseMessageComponent.ɵfac = function AgentResponseMessageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentResponseMessageComponent)(); };
AgentResponseMessageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentResponseMessageComponent, selectors: [["ycn-agent-response-message"]], inputs: { messageText: [1, "messageText"], includeResponseProfileImage: [1, "includeResponseProfileImage"], displayActions: [1, "displayActions"] }, decls: 7, vars: 4, consts: [["aiResponseElement", ""], ["ycnAgentLinkIntercept", "", 1, "pt-3", "pr-20", "pb-3", "pl-20", "bg-white", "rounded-4"], [1, "section-ai-response-content"], [1, "ai-md", 3, "innerHTML"], [3, "contentElement"], [1, "section-ai-response-link", "mb-2"], [1, "d-flex"], ["target", "_blank", 1, "text-underline", "text-blue", 3, "href"], [3, "textContent"]], template: function AgentResponseMessageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
        i0.ɵɵelement(2, "div", 3, 0);
        i0.ɵɵrepeaterCreate(4, AgentResponseMessageComponent_For_5_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "ycn-agent-message-copy-button", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const aiResponseElement_r4 = i0.ɵɵreference(3);
        i0.ɵɵclassProp("section-ai-response", ctx.includeResponseProfileImage());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHTML", ctx.messageHtml(), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵrepeater(ctx.displayActions());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("contentElement", aiResponseElement_r4);
    } }, dependencies: [AgentLinkInterceptDirective, AgentMessageCopyButtonComponent], encapsulation: 2, changeDetection: 0 });
